/* eslint-disable */
/*
* reports.js
*
* Description: Holds 'Stores' Logic for Module:'Reports'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew - Reports"
* Copyright 2018,2019,2020,2021 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
* @author Learek <michael.broeker@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> reports - reports ------------------------------
    reports_Reports: [
        {
            'id': 0,
            'title': '- "Invoice Report 1 - Month/Years"',
            'desc': ''
        },
        {
            'id': 1,
            'title': '- "Invoice Report 2 - From/To"',
            'desc': ''
        },
        {
            'id': 2,
            'title': '- "Missing Hotel and Proceeding Report"',
            'desc': ''
        },
        {
            'id': 3,
            'title': '- "Restriction violation Report"',
            'desc': ''
        },
        {
            'id': 5 ,
            'title': '- "Time Stats DT Report"',
            'desc': ''
        },
        {
            'id': 6 ,
            'title': '- "Time Stats FT Report"',
            'desc': ''
        },
        {
            'id': 7 ,
            'title': '- "Flights with Crews Report"',
            'desc': ''
        },
        {
            'id': 8 ,
            'title': '- "Crew Infos on Flight Report"',
            'desc': ''
        },
        // >>> Flyair41 ---------------
        {
            'id': 9 ,
            'title': '- "Base Report (Fly)"',
            'desc': ''
        },

    ],

    // >>> reports ----------------------------------------
    reports_Invoices: [],
    reports_Invoices_Filtered: [],

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Reports'
    ***************************************************************************/
    /***************************************************************************
    * get_Reports_Reports()
    *
    * Desc:
    * Note:
    *
    */
    get_Reports_Reports: state => {

        return state.reports_Reports;

    }, // eof get_Reports_Reports()




    /***************************************************************************
    * Getters: 'Reports'
    ***************************************************************************/
    /***************************************************************************
    * get_ReportsInvoices()
    *
    * Desc:
    * Note:
    *
    */
    get_ReportsInvoices: state => {

        return state.reports_Invoices;

    }, // eof get_ReportsInvoices()


    /***************************************************************************
    * get_ReportsInvoicesFiltered()
    *
    * Desc:
    * Note:
    *
    */
    get_ReportsInvoicesFiltered: state => {

        return state.reports_Invoices_Filtered;

    }, // eof get_ReportsInvoicesFiltered()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'Reports' - Load Invoices
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getInvoices()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_getInvoices: (state, payload) => {

        let filterableName = null,
            fullName = null;


        state.reports_Invoices = payload.response;
        state.reports_Invoices_Filtered = payload.response;

        state.reports_Invoices_Filtered.forEach((item) => {
            filterableName = item.genLastname + ', ' + item.genFirstName + ' ' + item.contract3Code;
            item.filterableName = filterableName;
            fullName = item.genLastname + ', ' + item.genFirstName;
            item.fullName = fullName;

            item.wasEdited = false;
        });

        // payload.context.commit('mut_filter_Resources');

    }, // eof mut_call_getInvoices()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Reports' - Download: 'Invoices Report'
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rest/humanresources/resource/invoicing/download'
    *
    * Desc:
    *
    */
    actn_call_download_InvoiceReport: (context, payload) => {

        let url = '',
            xhr = null;


        url = '/rest/humanresources/resource/invoicing/download';
        xhr = new XMLHttpRequest();
        xhr.open("PUT", url);
        xhr.setRequestHeader("apiKey", '037ae1f2ba244a2a93b24121743bfdd6');
        xhr.setRequestHeader("Authorization", payload.authheader);
        xhr.responseType = "arraybuffer";

        xhr.onload = function () {
            if (this.status === 200) {
                var blob = new Blob([xhr.response], { type: "application/csv" });
                var objectUrl = URL.createObjectURL(blob);
                window.open(objectUrl);
            }
        };
        xhr.send(JSON.stringify(payload.params));

    }, // eo function actn_call_download_InvoiceReport()




    /***************************************************************************
    * Actions: 'Reports' - Download: 'Time Stats Report'
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rest/humanresources/statistics/download/{2020}'
    *
    * Desc:
    *
    */
    actn_call_download_TimeStatsReport: (context, payload) => {

        let url = '',
            xhr = null;


        url = '/rest/humanresources/statistics/download/' + payload.params.year;
        xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.setRequestHeader("apiKey", '037ae1f2ba244a2a93b24121743bfdd6');
        xhr.setRequestHeader("Authorization", payload.authheader);
        xhr.responseType = "arraybuffer";

        xhr.onload = function () {
            if (this.status === 200) {
                var blob = new Blob([xhr.response], { type: "application/csv" });
                var objectUrl = URL.createObjectURL(blob);
                window.open(objectUrl);
            }
        };
        xhr.send();

    }, // eo function actn_call_download_TimeStatsReport()

    /***************************************************************************
    * Call::'/rest/humanresources/statistics/download/{2020}/ft'
    *
    * Desc:
    *
    */
    actn_call_download_TimeStatsReport_FT: (context, payload) => {

        let url = '',
            xhr = null;


        url = '/rest/humanresources/statistics/download/' + payload.params.year + '/ft';
        xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.setRequestHeader("apiKey", '037ae1f2ba244a2a93b24121743bfdd6');
        xhr.setRequestHeader("Authorization", payload.authheader);
        xhr.responseType = "arraybuffer";
        Vue.prototype.$vp_m();

        xhr.onload = function () {
            if (this.status === 200) {
                var blob = new Blob([xhr.response], { type: "application/csv" });
                var objectUrl = URL.createObjectURL(blob);
                window.open(objectUrl);

                Vue.prototype.$vp_um();
            }
        };
        xhr.send();

    }, // eo function actn_call_download_TimeStatsReport_FT()




    /***************************************************************************
    * Actions: 'Reports' - Load Invoices
    ***************************************************************************/
    /***************************************************************************
    * Call::'humanresources/resource/invoicing'
    *
    * Desc:
    *
    */
    actn_call_getInvoices: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/humanresources/resource/invoicing', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getInvoices', { response: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                 Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getInvoices()




    /***************************************************************************
    * Actions: 'Reports' - Download: 'Restriction Violation Report'
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rest/humanresources/duty/report/list/download'
    *
    * Desc:
    *
    */
    actn_call_download_RestrictionViolationReport: (context, payload) => {

        let url = '',
            xhr = null;


        url = '/rest/humanresources/duty/report/list/download';
        xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.setRequestHeader("apiKey", '037ae1f2ba244a2a93b24121743bfdd6');
        xhr.setRequestHeader("Authorization", payload.authheader);
        xhr.responseType = "arraybuffer";

        xhr.onload = function () {
            if (this.status === 200) {
                var blob = new Blob([xhr.response], { type: "application/csv" });
                var objectUrl = URL.createObjectURL(blob);
                window.open(objectUrl);
            }
        };
        xhr.send();

    }, // eo function actn_call_download_RestrictionViolationReport()


    /***************************************************************************
    * Call::'/rest/humanresources/resource/errors/download'
    *
    * Desc:
    *
    */
    actn_call_download_MissingHotelsReport: (context, payload) => {

        let url = '',
            xhr = null;


        url = '/rest/humanresources/dutyplan/errors/download';
        xhr = new XMLHttpRequest();
        xhr.open("PUT", url);
        xhr.setRequestHeader("apiKey", '037ae1f2ba244a2a93b24121743bfdd6');
        xhr.setRequestHeader("Authorization", payload.authheader);
        xhr.responseType = "arraybuffer";

        xhr.onload = function () {
            if (this.status === 200) {
                var blob = new Blob([xhr.response], { type: "application/csv" });
                var objectUrl = URL.createObjectURL(blob);
                window.open(objectUrl);
            }
        };
        xhr.send(JSON.stringify(payload.params));

    }, // eo function actn_call_download_MissingHotelsReport()


    /***************************************************************************  // Flyair41
    * Call::'/rest/humanresources/resource/locations'
    *
    * Desc:
    *
    */
    actn_call_download_BaseReport: (context, payload) => {

        let url = '',
            xhr = null;


        url = '/rest/humanresources/resource/locations';
        xhr = new XMLHttpRequest();
        xhr.open("PUT", url);
        xhr.setRequestHeader("apiKey", '037ae1f2ba244a2a93b24121743bfdd6');
        xhr.setRequestHeader("Authorization", payload.authheader);
        xhr.responseType = "arraybuffer";

        xhr.onload = function () {
            if (this.status === 200) {
                var blob = new Blob([xhr.response], { type: "application/csv" });
                var objectUrl = URL.createObjectURL(blob);
                window.open(objectUrl);
            }
        };
        xhr.send(JSON.stringify(payload.params));

    }, // eo function actn_call_download_BaseReport()


    /***************************************************************************
    * Call::'/rest/acm/flights/report/shop'
    *
    * Desc:
    *
    */
    actn_call_download_CrewWithFlightsReport: (context, payload) => {

        let url = '',
            xhr = null;


        url = '/rest/acm/flights/report/shop';
        xhr = new XMLHttpRequest();
        xhr.open("PUT", url);
        xhr.setRequestHeader("apiKey", '037ae1f2ba244a2a93b24121743bfdd6');
        xhr.setRequestHeader("Authorization", payload.authheader);
        xhr.responseType = "arraybuffer";

        xhr.onload = function () {
            if (this.status === 200) {
                var blob = new Blob([xhr.response], { type: "application/csv" });
                var objectUrl = URL.createObjectURL(blob);
                window.open(objectUrl);
            }
        };
        xhr.send(JSON.stringify(payload.params));

    }, // eo function actn_call_download_CrewWithFlightsReport()


    /***************************************************************************
    * Call::'/rest/humanresources/flight/crew/report'
    *
    * Desc:
    *
    */
    actn_call_download_CrewInfosOnFlightsReport: (context, payload) => {

        let url = '',
            xhr = null;


        url = '/rest/humanresources/flight/crew/report';
        xhr = new XMLHttpRequest();
        xhr.open("PUT", url);
        xhr.setRequestHeader("apiKey", '037ae1f2ba244a2a93b24121743bfdd6');
        xhr.setRequestHeader("Authorization", payload.authheader);
        xhr.responseType = "arraybuffer";
        Vue.prototype.$vp_m();

        xhr.onload = function () {
            if (this.status === 200) {
                var blob = new Blob([xhr.response], { type: "application/csv" });
                var objectUrl = URL.createObjectURL(blob);
                console.log('I am here')
                window.open(objectUrl);

                Vue.prototype.$vp_um();
            }
        };
        xhr.send(JSON.stringify(payload.params));

    }, // eo function actn_call_download_CrewInfosOnFlightsReport()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};
